import Vue from 'vue';

import { i18n } from '@kano/i18n';

import TrustpilotCarousel from './components/Trustpilot/TrustpilotCarousel.vue';

const loader = document.getElementById('trustpilot-carousel-loader')!;
const lazyBlock = document.getElementById('trustpilot-block-lazy');

function init() {
  if (!document) {
    return;
  }

  new Vue({
    i18n,
    render: h => h(TrustpilotCarousel),
    mounted() {
      loader.remove();
      if(lazyBlock) lazyBlock.remove();
    },
  }).$mount('#trustpilot-carousel-app');
}

init();